export default __webpack_public_path__ + "static/media/businesswomanjpg-edit.86a756a0.png";